var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Número do Ofício", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input w-70",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.oficio.numeroOficio,
                      callback: function($$v) {
                        _vm.$set(_vm.oficio, "numeroOficio", $$v)
                      },
                      expression: "oficio.numeroOficio"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Município", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input w-70",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.oficio.cartorio.municipio.nome,
                      callback: function($$v) {
                        _vm.$set(_vm.oficio.cartorio.municipio, "nome", $$v)
                      },
                      expression: "oficio.cartorio.municipio.nome"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin-bottom", attrs: { type: "flex" } },
            [
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Nome do Cartório", required: true }
                  }),
                  _c("el-input", {
                    staticClass: "input w-70",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.oficio.cartorio.nome,
                      callback: function($$v) {
                        _vm.$set(_vm.oficio.cartorio, "nome", $$v)
                      },
                      expression: "oficio.cartorio.nome"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "container-input", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Data de Emissão do Ofício",
                      required: true
                    }
                  }),
                  _c("el-input", {
                    staticClass: "input w-70",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.dataEmissao,
                      callback: function($$v) {
                        _vm.dataEmissao = $$v
                      },
                      expression: "dataEmissao"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("app-pdf-editor", {
            attrs: { conteudo: _vm.conteudo },
            on: {
              onTextChange: _vm.onTextChange,
              getRawDocument: _vm.getRawDocument
            }
          })
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c("el-button", { on: { click: _vm.salvarEdicao } }, [
              _c("i", { staticClass: "fal fa-file-pdf" }),
              _c("span", [_vm._v("  Salvar Edição")])
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d91ad9f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d91ad9f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/ModalEditarOficio.vue
// module id = null
// module chunks = 